import React, { Component } from 'react';

//React-PDF dependencies
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import PdfIcon from './PdfIcon';
import QuestionPdf from './QuestionPdf';

// Lodash
import _ from 'lodash';

const styles = StyleSheet.create({
  card: {
    display: "flex",
    flexDirection: "column",
    margin: '8 0',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: "#d9d9d9",
    width: "100%",
    padding: '0 10',
    title: {
      marginTop: 2,
      fontSize: 13,
      fontWeight: 900,
      fontFamily: 'Roboto',
    },
    primaryIcon: {
      alignItems: 'center',
      justifyContent: 'center',
      width: 30,
      height: 30,
      margin: 7,
      backgroundColor: process.env.REACT_APP_PRIMARY_COLOR,
      borderRadius: 40,
      icon:{
        width: 18,
      },
    },
    column: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    row: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    subHeader: {
      marginTop: 2,
      background: '#000000',
      opacity: 0.5,
      fontSize: 10,
      fontFamily: 'Roboto',
    },
    text: {
      left: 10,
      fontSize: 12,
      fontFamily: 'Roboto',
    },
  },
  prcText: {
    display: 'inline-flex',
    flexDirection: 'column',
    fontSize: 16,
    height: 40,
    position: 'relative',
    padding: 5,
    label: {
      fontSize: 10,
      color: '#000000',
      opacity: 0.3,
      paddingTop: 16,
      fontFamily: 'Roboto',
    },
    input: {
      fontSize: 12,
      fontFamily: 'Roboto',
    },
  },
  prcContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    margin: 5,
    column: {
      display: 'flex',
      flexDirection: 'row',
    },
  },
});

const PRCText = ({ children, ...props }) => (
  <View style={styles.prcText}>
    <Text style={styles.prcText.label} {...props}>
      {props.label}
    </Text>
    <Text style={styles.prcText.input} {...props}>
      {children}
    </Text>
  </View>
);

class PRChecklistPdf extends Component {

  render() {

    const { data } = this.props;
    let event = new Date(Date.parse(this.props.prc.date))
    const questionsSorted = _.orderBy(this.props.prc.questionGroup.questions, function (obj) {
        return parseInt(obj['position'], 10);
    });
    const questionsList = questionsSorted.map((question, id) =>
        <QuestionPdf question={question} key={id} data={data}/>
    );

    return(
      <View style={this.props.style}>
        <View style={styles.card.column}>
          <PdfIcon
            src="https://img.icons8.com/ios-filled/100/FFFFFF/task-planning.png"
            style={styles.card.primaryIcon}
          />
          <View style={styles.card.row}>
            <Text style={styles.card.title}>
              Post Remediation Checklist
            </Text>
            <Text style={styles.card.subHeader}>
              {"On " + event.toDateString() + " at " + event.getHours() + ":" + event.getMinutes() + ":" + event.getSeconds()}
            </Text>
          </View>
        </View>
        <View style={styles.prcContainer}>
          <View style={styles.prcContainer.column}>
            <PRCText label={"Supervisor"}> {this.props.prc.questionGroup.device.user.fullName} </PRCText>
            <PRCText label={"Enclosure"}> {this.props.prc.enclosure.name} </PRCText>
          </View>
        </View>
        <View style={styles.card}>
          <View style={styles.card.column}>
            <PdfIcon
              src="https://img.icons8.com/ios-filled/100/FFFFFF/messaging-.png"
              style={styles.card.primaryIcon}
            />
            <Text style={styles.card.text}>
              Questions
            </Text>
          </View>
          {questionsList}
        </View>
      </View>
    );
  }
}

export default PRChecklistPdf;


// WEBPACK FOOTER //
// src/components/innerComponents/pdfComponents/PRChecklistPdf.js